var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2023 3.93921L7.63984 0.65796C7.55188 0.614054 7.44812 0.614054 7.36031 0.65796L0.797812 3.93921C0.691875 3.99218 0.625 4.1003 0.625 4.21874V10.7812C0.625 10.8997 0.691875 11.0078 0.797656 11.0608L7.36016 14.342C7.40422 14.3641 7.45203 14.375 7.5 14.375C7.54797 14.375 7.59578 14.3641 7.63984 14.342L14.2023 11.0608C14.3081 11.0078 14.375 10.8997 14.375 10.7812V4.21874C14.375 4.1003 14.3081 3.99218 14.2023 3.93921ZM7.5 1.28687L13.3638 4.21874L12.1094 4.84593L6.24578 1.91405L7.5 1.28687ZM9.60938 6.09593L3.74563 3.16405L5.54688 2.26343L11.4106 5.1953L9.60938 6.09593ZM9.84375 6.67749L11.7188 5.73999V8.06452L11.1191 7.63624C11.0511 7.58765 10.9661 7.56843 10.8837 7.58265C10.8014 7.59718 10.7281 7.6439 10.6805 7.71265L9.84375 8.92155V6.67749ZM3.04688 3.51343L8.91047 6.4453L7.5 7.15062L1.63625 4.21874L3.04688 3.51343ZM1.25 4.72437L7.1875 7.69312V13.5567L1.25 10.588V4.72437ZM7.8125 13.5569V7.69312L9.21875 6.98999V9.92187C9.21875 10.0586 9.3075 10.1794 9.43797 10.2201C9.46891 10.2298 9.50016 10.2344 9.53125 10.2344C9.63188 10.2344 9.72875 10.1856 9.78828 10.0998L11.0141 8.32937L11.8498 8.92624C11.9452 8.99421 12.0705 9.00343 12.1744 8.94968C12.2783 8.89624 12.3438 8.7889 12.3438 8.67187V5.42749L13.75 4.72437V10.588L7.8125 13.5569Z",
    fill: "#3CBD96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.689df73ea1380b997608c90f9e9c92f7.svg";
export { ForwardRef as ReactComponent };